import { ref } from '@vue/composition-api'
import eventsApi from '@/services/api/events'
import EventBus from '@/store/EventBus'

export default function useDraftEventsDashboard({ onError, onSuccess } = {}) {
  const openDraftId = ref(null)
  const events = ref([])
  const totals = ref(null)
  const loadingEvents = ref(false)

  function emitError(msg) {
    if (onError) onError(msg)
    else EventBus.$emit('http-error', msg)
  }

  function emitSuccess(msg) {
    if (onSuccess) onSuccess(msg)
    else EventBus.$emit('show-success', msg)
  }

  async function load(draftId) {
    loadingEvents.value = true
    try {
      const res = await eventsApi.nominationsDashboard(draftId)
      events.value = res.data.data
      totals.value = res.data.meta != null ? res.data.meta.totals : null
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null ? data.message : 'Failed to load events.'
      emitError(msg)
    } finally {
      loadingEvents.value = false
    }
  }

  async function toggle(draftId) {
    if (openDraftId.value === draftId) {
      openDraftId.value = null
      events.value = []
      totals.value = null
      return
    }
    openDraftId.value = draftId
    await load(draftId)
  }

  async function reload() {
    if (openDraftId.value != null) {
      await load(openDraftId.value)
    }
  }

  async function lockEvent(eventId, isLocked) {
    try {
      const res = await eventsApi.lock(eventId, isLocked)
      emitSuccess(res.data != null && res.data.message != null ? res.data.message : 'Event lock updated.')
      const idx = events.value.findIndex(e => e.id === eventId)
      if (idx !== -1) {
        events.value.splice(idx, 1, { ...events.value[idx], is_locked: isLocked })
      }
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null ? data.message : 'Failed to update event lock.'
      emitError(msg)
    }
  }

  return { openDraftId, events, totals, loadingEvents, toggle, reload, lockEvent }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDraftEventsDashboard.js